<template>
  <div class="timezone-select-field">
    <v-select
      v-bind="$attrs"
      :value="value"
      :items="allVariants"
      attach
      chips
      deletable-chips
      small-chips
      :label="label"
      :hint="hint"
      persistent-hint
      multiple
      outlined
      item-text="name"
      item-value="value"
      :loading="loading"
      :disabled="loading"
      @input="emitInput"
    ></v-select>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'EnumValueMultiSelectField',
    props: {
      value: {
        type: Array,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      emptyText: {
        type: String,
        default: null,
      },
      enumClass: null,
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      allVariants () {
        return this.enumClass ? this.enumClass.getAllVariants() : []
      },
      showEmptyText () {
        return this.emptyText && _.isEmpty(this.value) && !this.loading
      },
      hint () {
        return this.showEmptyText ? this.emptyText : null
      },
    },
    methods: {
      emitInput (value) {
        if (_.isEmpty(value)) {
          value = null
        }
        this.$emit('input', value)
      },
    },
    created () {
      if (!this.enumClass) {
        throw new Error('enumClass not defined in EnumValueSelectField component')
      }
    },
  }
</script>

<style scoped>

</style>
